import { cn } from '@tripleten/cn';

export const cnLink = cn('link');
